import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import SelectNew from '../../../../components/UI/SelectNew';
import { Button } from '../../../../components/UI/ComponentsUI';
import { endLoading, startLoading } from '../../../../actions/loadingAction';

const StorageContainerRequired = (props) => {
    const [container, setContainer] = useState();

    useEffect(() => {
        if (props.container) {
            setContainer({ ...props.container });
        }
        if (!props.containerTypes) props.getContainerTypes();
        if (!props.containerSizes) props.getContainerSizes();
    }, [props.container]);


    const onChange = (event) => {
        onValueChange(event, container, setContainer);
    };

    const updateContainer = () => {
        if (validateInputsRequired("UpdateContainerStorage")) {
            props.startLoading();
            props.containerUpdate(container, () => {
                props.endLoading();
                if (props.confirmUpdate) {
                    props.confirmUpdate()
                }
            })
        }
    };

    return (

        <form id="UpdateContainerStorage">
            <div className="sixth-text-color center">
                <span className="title col s12">Atualizar dados container obrigatório(s)</span>
            </div>
            <div className="row" style={{ marginBottom: '0px' }}>
                {
                    container?.type &&
                    <div className="no-padding col s12">
                        <SelectNew
                            required
                            id="type"
                            name="type"
                            placeHolder={translate('choose-one-option', 'general')}
                            label={translate('fields.type', 'container')}
                            data={props.containerTypes?.map((x) => ({ id: x.id, text: x.containerTypeName }))}
                            change={onChange}
                            value={container?.type || ""}
                        />
                    </div>
                }
                {
                    container?.size &&
                    <div className="no-padding col s12">
                        <SelectNew
                            required
                            id="size"
                            name="size"
                            placeHolder={translate('choose-one-option', 'general')}
                            label={translate('fields.size', 'container')}
                            data={props.containerSizes?.map((x) => ({ id: x.id, text: x.containerSizeName }))}
                            change={onChange}
                            value={container?.size || ""}
                        />
                    </div>
                }
            </div>
            <div className="row" style={{ paddingTop: '5px' }}>
                <Button full="true"
                    text="Atualizar Dados"
                    onClick={updateContainer} />
            </div>
        </form>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        containerTypes: state.containerReducer.containerTypes,
        containerSizes: state.containerReducer.containerSizes,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContainerSizes: () => {
            dispatch(ContainerService.getContainerSizes());
        },
        getContainerTypes: () => {
            dispatch(ContainerService.getContainerTypes());
        },
        containerUpdate: (container, callback) => {
            dispatch(ContainerService.updateContainerByAllocation(container, callback));
        },
        startLoading: () => {
            dispatch(startLoading());
        },
        endLoading: () => {
            dispatch(endLoading());
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StorageContainerRequired));
